/* eslint-disable camelcase */
/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Document } from '@contentful/rich-text-types'
import RichTextBlock from '../ev-rich-text-block'
import { Icon } from '../../atoms'
import { blueberry, white } from '../../css/variables'
import { getComponentById } from '../../redux/component/component-selectors'
import { connect } from 'react-redux'
import { FsCore } from '../../types/fs-core'

interface Props {
  uconsentSource: string
  consentText?: string
  consentSource: string
  successMessage: string
  variant: string
  sys: { id: string }
  header: Document
  copy: Document
  footer: Document
  submitButtonText: string
  secondaryConsent?: string
  secondaryConsentText?: string
}

export const moneyRichTextBlockStyles = {
  h2: {
    fontFamily: 'Nunito',
    color: blueberry,
    padding: 0,
    margin: 0,
    fontWeight: 600,
    fontSize: '30px',
    lineHeight: '120%',
    marginBottom: '12px',
    '@media screen and (min-width: 768px)': {
      fontSize: '36px',
    },
  },
  p: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '150%',
    padding: 0,
    margin: 0,
    marginBottom: '24px',
  },
}

export const moneyRichTextBlockFooterStyle = {
  p: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '150%',
    padding: 0,
    margin: 0,
    textAlign: 'center',
  },
}

const EmailCaptureForm = (props: Props) => {
  const {
    uconsentSource: consentName,
    consentText,
    consentSource,
    successMessage,
    variant,
    sys,
    header,
    copy,
    footer,
    submitButtonText,
    secondaryConsent,
    secondaryConsentText,
  } = props

  const currentClassName = variant === 'email-capture' ? 'EmailCapture' : 'EmailCapturePrimary'
  const textColour = variant === 'email-capture' ? blueberry : white
  return (
    <div className={variant === 'email-capture-primary' ? 'EmailCapturePrimary__wrap' : ''}>
      <div data-email-capture className={currentClassName}>
        <div
          className='EmailCapture__capture'
          data-consent-source={consentSource}
          data-consent-name={consentName}
          data-email-capture-consent
        >
          {/* Capture Form */}
          <div className={`${currentClassName}__box`} data-email-capture-box>
            <RichTextBlock {...header} style={moneyRichTextBlockStyles} />
            <div className={`${currentClassName}__box__copy`}>
              <RichTextBlock {...copy} style={moneyRichTextBlockStyles} />
            </div>

            <div className='EmailCapture__box__form'>
              <div className='EmailCapture__box__form__email'>
                <input
                  placeholder='Email'
                  className='EmailCapture__box__form__input'
                  data-email-capture-input
                />
                {secondaryConsent && (
                  <div className='EmailCapture__box__form__secondaryConsent'>
                    <input
                      type='checkbox'
                      data-email-capture-secondary-consent={secondaryConsent}
                    />
                    <div className='EmailCapture__box__form__secondaryConsent__text'>
                      {secondaryConsentText}
                    </div>
                  </div>
                )}
              </div>

              <button
                tabIndex={0}
                disabled
                className={`${currentClassName}__box__form__button`}
                data-email-capture-submit
                data-click-tracking={JSON.stringify({
                  component_category: 'platinum-component',
                  component_id: sys?.id,
                  component_name: 'EmailCaptureForm',
                  contentful_variant: variant,
                  additionalProps: { text: submitButtonText },
                })}
              >
                {submitButtonText}
              </button>
            </div>
            {consentText && (
              <div className='EmailCapture__box__form__consentText'>{consentText}</div>
            )}

            <RichTextBlock {...footer} style={moneyRichTextBlockFooterStyle} />
          </div>
        </div>

        {/* Success */}
        <div className='EmailCapture__success' data-email-capture-success>
          <div className='EmailCapture__success__tickCircle'>
            <Icon glyph={'tick-circle'} brand='money' size={36} color={textColour} />
          </div>
          <div className='EmailCapture__success__header' style={{ color: textColour }}>
            {successMessage}
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect((state: FsCore.State, props: any) => {
  return {
    secondaryConsentText: getComponentById(state, props.sys.id)?.secondaryConsentText,
    consentText: getComponentById(state, props.sys.id)?.consentText,
    ...props,
  }
})(EmailCaptureForm)
